export default __webpack_public_path__ + "static/bg-tech-nation--mobile-0555c8431760ca44c1823764a65c6a8c.png";